import { SPACING } from '@alto/design-library-tokens';
import { Body, Button, useScreenSize } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import delivery from '~shared/assets/images/delivery@2x.png';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { useOrderSuccessViewed } from '~shared/lib/analytics/src/hooks/useOrderSuccessViewed';
import { HeaderImage, LARGE_SIZE } from '~web/components/HeaderImage';
import { PageBackground, SingleColumnContentWrapper } from '~web/components/Page';

const AdjustedPageBackground = styled(PageBackground)<{ white?: boolean; isLGScreenOrBigger: boolean }>`
  padding-top: 80px;
  padding-bottom: ${SPACING.STATIC.XL.rem};
  ${({ isLGScreenOrBigger }) => !isLGScreenOrBigger && `padding-top: 80px; padding-bottom: ${SPACING.STATIC.XL.rem};`}
`;

type OrderSuccessRouteParams = {
  readonly shipmentID: string;
};

export const OrderSuccess = () => {
  useOrderSuccessViewed();

  const { shipmentID } = useParams<OrderSuccessRouteParams>();
  const { isLGScreenOrBigger } = useScreenSize();
  const { navigate } = useNavigation();

  const handleViewDelivery = () => {
    navigate('RouteOrderDetails', { shipmentID: Number(shipmentID), state: { origin: ORIGIN_NAMES.CHECKOUT } });
  };

  return (
    <AdjustedPageBackground
      isLGScreenOrBigger={isLGScreenOrBigger}
      white
    >
      <SingleColumnContentWrapper>
        <div>
          <HeaderImage
            src={delivery}
            alt={IMG_ALT_TEXTS.delivery}
            title="Order scheduled!"
            imgSize={LARGE_SIZE}
          />
          <Body center>Your delivery has been scheduled. We’ll be sure to remind you when it’s on the way.</Body>
        </div>
        <Button
          type="primary"
          onPress={handleViewDelivery}
        >
          View Delivery
        </Button>
      </SingleColumnContentWrapper>
    </AdjustedPageBackground>
  );
};
